import { motion, type MotionProps } from "framer-motion";
import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export type BadgeProps = HTMLAttributes<HTMLDivElement> & MotionProps;

export const Badge = ({ className, children, ...props }: BadgeProps) => (
	<motion.div
		className={cn(
			"px-[8px] py-[6px] rounded-[6px] bg-bg-regular text-ct-regular text-xs font-normal",
			className,
		)}
		{...props}
	>
		{children}
	</motion.div>
);
